import React from "react";
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import Fade from 'embla-carousel-fade';
import {
    CardMedia
} from '@mui/material';

import "./styles.css";

export default function MainCarousel({ data }) {
    const [emblaRef] = useEmblaCarousel({ loop: true, duration: 30 }, [
        Autoplay({ delay: 5000, stopOnInteraction: false }),
        Fade()
    ]);

    return (
        <div className="embla" ref={emblaRef} style={{ overflow: 'hidden', height: '100%', width: '100%' }}>
            <div className="embla__container" style={{ display: 'flex', height: '100%' }}>
                {
                    data.map((item, i) => (
                        <div className="embla__slide" key={`question-media-${item}-${i}`} style={{ flex: '0 0 100%', minWidth: 0, height: '100%', position: 'relative' }}>
                            <CardMedia
                                className="QuestionMedia"
                                image={item}
                                title={item}
                                sx={{ height: '100%', width: '100%' }}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    );
}